<!-- Usage   -->
<!--
<sa-label #Group [(text)]="Idea.Group" [title]="'Group'" ></sa-label>
-->
<div class="sa-form-group">
  <label class="sa-form-label">{{title}}</label>
  <input type="text" class="form-control sa-formfield-input" [ngModel]="text" disabled>
  <!--<label class="sa-formfield-label">{{title}} <span *ngIf="required != 'none'" style="color:red"> *</span></label>-->
</div>
